import { getUserProfileAsync } from "@chr/online-shared-microsite-core";

export const hasUserProfile = async () => {
  return await getUserProfileAsync() !== null;
}
